/**
 * Scroll-to-specs link safety net (E20-1159)
 *
 * The "Scroll to all specs" link (product overview) is rendered whenever the
 * product has Specs & Warranty content, so the native anchor works without JS.
 * But a template could, in theory, include the overview without placing the
 * Specs & Warranty section — leaving the link pointing at a #product-specs
 * anchor that isn't on the page. This removes those orphan links so shoppers
 * never click a jump that goes nowhere. Smooth scrolling itself is handled by
 * bfx-anchor-scroll (E20-1160).
 */
const hideOrphanSpecsLinks = () => {
  document.querySelectorAll('.js-specs-link').forEach((link) => {
    const targetId = link.dataset.specsTarget || 'product-specs';
    if (!document.getElementById(targetId)) {
      link.hidden = true;
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hideOrphanSpecsLinks, { once: true });
} else {
  hideOrphanSpecsLinks();
}
